import React, { useEffect, useState } from "react";
import { getCustomerProfile } from "../../api";
import "./CustomerProfile.css";

const CustomerProfile = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getCustomerProfile();
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="profile-container">
      <h2>Customer Profile</h2>
      <p>
        <strong>Name:</strong> {profile.first_name} {profile.last_name}
      </p>
      <p>
        <strong>Email:</strong> {profile.email}
      </p>
      <p>
        <strong>Phone No:</strong> {profile.phone_no}
      </p>
      <p>
        <strong>Created At:</strong>{" "}
        {new Date(profile.customer_created_at).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </p>
    </div>
  );
};

export default CustomerProfile;
